import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import ErrorMessage from 'uI/ErrorMessage/ErrorMessage';
import Loading from 'uI/Loading/Loading';

import { setChangePassword } from 'store/myAccount-actions';

import classes from './ChangePassword.module.css';

const ChangePassword = () => {
  const [errorChangePassword, setErrorChangePassword] =
    useState(false);
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] =
    useState(false);

  useEffect(() => {
    setErrorChangePassword(false);
    setMessage('');
  }, [password, newPassword, confirmPassword]);

  const changeInputHandler = type => event => {
    if (type === 'password') {
      setPassword(event.target.value);
    } else if (type === 'newPassword') {
      setNewPassword(event.target.value);
    } else {
      setConfirmPassword(event.target.value);
    }
  };

  const handleClickShowPassword = type => () => {
    if (type === 'current') {
      setShowPassword(!showPassword);
    } else if (type === 'new') {
      setShowNewPassword(!showNewPassword);
    } else {
      setShowConfirmNewPassword(!showConfirmNewPassword);
    }
  };

  const changePasswordHandler = () => {
    if (newPassword !== confirmPassword) {
      setErrorChangePassword(true);
      setMessage('Las contraseñas no coinciden');
    } else {
      setLoading(true);
      (async () => {
        let change = await setChangePassword(
          password,
          newPassword,
          confirmPassword
        );
        if (!change) {
          setErrorChangePassword(true);
          setMessage('Las contraseña actual es incorrecta');
        }
        setLoading(false);
      })();
    }
  };

  return (
    <>
      <aside className={classes.descriptionSection}>
        <p className={classes.title}>Mi Contraseña</p>
        <p className={classes.subtitle}>
          Utiliza esta sección para actualizar tu contraseña
        </p>
      </aside>
      <div className={classes.changePasswordContainer}>
        <TextField
          placeholder="Contraseña actual"
          value={password}
          type={showPassword ? 'text' : 'password'}
          onChange={changeInputHandler('password')}
          className={classes.input}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClickShowPassword('current')}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )
          }}
          label="Contraseña actual"
        />
        <TextField
          value={newPassword}
          placeholder="Nueva contraseña actual"
          type={showNewPassword ? 'text' : 'password'}
          onChange={changeInputHandler('newPassword')}
          className={classes.input}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClickShowPassword('new')}
                  edge="end"
                >
                  {showNewPassword ? (
                    <VisibilityOff />
                  ) : (
                    <Visibility />
                  )}
                </IconButton>
              </InputAdornment>
            )
          }}
          label="Nueva contraseña actual"
        />
        <TextField
          placeholder="Confirmar contraseña"
          type={showConfirmNewPassword ? 'text' : 'password'}
          onChange={changeInputHandler('confirmPassword')}
          className={classes.input}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClickShowPassword('confirm')}
                  edge="end"
                >
                  {showConfirmNewPassword ? (
                    <VisibilityOff />
                  ) : (
                    <Visibility />
                  )}
                </IconButton>
              </InputAdornment>
            )
          }}
          value={confirmPassword}
          label="Confirmar contraseña"
        />
        {!loading ? (
          <Button
            onClick={changePasswordHandler}
            className={classes.saveBtn}
            disabled={
              password.length < 8 ||
              newPassword.length < 8 ||
              confirmPassword.length < 8
            }
          >
            Guardar cambios
          </Button>
        ) : (
          <Loading />
        )}

        {errorChangePassword && (
          <ErrorMessage
            open={errorChangePassword}
            message={message}
          />
        )}
      </div>
    </>
  );
};

ChangePassword.propTypes = {
  // eslint-disable-next-line react/require-default-props
  userData: PropTypes.array
};

export default ChangePassword;
